import React, { useState } from 'react';
import { Button, Typography, InputBase, Box, Grid } from '@mui/material';
import PasswordGuidelines from '~/_base/components/passwordGuidelines';

export default function EnterNewPassword() {
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  function handleRequestPasswordClick() {
    document.getElementsByTagName('form')[0].submit();
  }

  function handleKeyPress(
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    e.preventDefault();
    if (e.key === 'Enter') {
      handleRequestPasswordClick();
    }
  }

  function shouldRender() {
    const elements = document.querySelectorAll(
      "[data-mount='ape_password_reset_enter_details']"
    );
    return elements.length > 0;
  }

  if (!shouldRender()) {
    return <div />;
  }

  return (
    <Grid container>
    <Grid size={{xs: 12, sm: 6, md: 6}}>
        <PasswordGuidelines />
      </Grid>
      <Grid size={{xs: 12, sm: 6, md: 6}}>
        <Typography variant="h1">Reset Password</Typography>
        <Typography variant="body1" sx={{ my: 3, mx: 0 }}>
          Please enter and confirm a new password below.
        </Typography>
        <Box sx={{ mb: 1 }}>
          <InputBase
            onKeyUp={e => handleKeyPress(e)}
            id="user_password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            name="user[password]"
            type="password"
            fullWidth
            placeholder="New password"
          />
        </Box>
        <Box sx={{ mb: 1 }}>
          <InputBase
            onKeyUp={e => handleKeyPress(e)}
            id="user_password_confirmation"
            value={passwordConfirm}
            onChange={e => setPasswordConfirm(e.target.value)}
            name="user[password_confirmation]"
            type="password"
            fullWidth
            placeholder="Password confirmation"
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 5, width: '100%' }}
          type="button"
          onClick={() => handleRequestPasswordClick()}
        >
          Reset Password
        </Button>
      </Grid>
    </Grid>
  );
}
